export const ERROR_MESSAGES = {
    INVALID_EMAIL: 'The email address provided is invalid.',
    USER_NOT_FOUND: 'User not found. Please check the entered details.',
    EMAIL_NOT_FOUND: 'Email not found. Please ensure you have entered the correct email address.',
    ACCOUNT_CREATION_ERROR: 'An error occurred during account creation. Please try again later.',
    ACCOUNT_DEACTIVATED: 'Your account has been deactivated. Please contact support for assistance.',
    EMAIL_VERIFIED_ERROR: 'There was an issue verifying your email. Please try again or contact support.',
    TOKEN_NOT_VALID: 'Your session has expired. Please log in again to continue.',
    OTP_SENT_ERROR: 'Failed to send OTP. Please check your email and try again later.',
    INVALID_LOGIN: 'Invalid login credentials. Please try again.',
    EMAIL_DOES_NOT_EXISTS: 'The email address does not exist in our system.',
    EMAIL_ALREADY_EXISTS: 'The email address is already registered. Please use a different email or log in.',
    INVALID_OTP:  'The OTP entered is invalid. Please check and try again.',
    OLD_PASSWORD_NOT_MATCH: 'The current password you entered does not match our records.',
    OLD_NEW_PASS_SAME: 'The new password cannot be the same as the current password. Please choose a different password.',
    PHONE_ALREADY_EXISTS: 'The phone number you entered already exists in our system. Please try another number.',
    FORGOT_EMAIL_VERIFIED_ERROR: 'Your email is not verified. Please log in with your sign-up credentials to verify your email or sign up with new credentials to proceed.',
    ALREADY_EXISTS: 'Please try with a different plan name & number of downloads, as the same record already exists.',
    ACCOUNT_REJECTED: 'The email address is no longer registered with us. Due to inadequate profile information, Admin has rejected your account. Please contact admin or sign up again.',
    UPLOAD_ERROR: 'Upload has been failed. Please try again!',
    COMPANY_PROFILE_BLOCKED: 'Your company profile has been rejected. Please contact support for assistance, or try signing up with different credentials.',
    USER_DEACTIVATED: 'Your account has been deactivated. Please contact support for assistance.',
    FILE_REQUIRED_ERROR: 'A file is required. Please upload a valid file.',
    FILE_INVALID_ERROR: 'The file uploaded is invalid. Please upload a valid file format.',
    FILE_INVALID_NAME_REGEX: 'The file name contains invalid characters. Please rename the file and try again.',
    FILE_URL_REQUIRED_ERROR: 'A file URL is required. Please provide a valid file URL.',
    FILE_URL_INVALID_ERROR: 'The provided file URL is invalid. Please ensure the URL is correct.',
    FILE_URL_INVALID_REGEX: 'The file URL contains invalid characters. Please check the URL and try again.',
    JOB_ERROR: 'Generate job description getting failed! Please try again.',
    WEBSITE_INVALID: 'Web address you provided is invalid. Please check and try again.',
    AI_CHAT_LOCATION_ERROR: 'Location information could not be retrieved. Please try again.',
    AI_CHAT_ERROR: 'An error occurred with the chat feature. Please try again.',
    JOB_CREATION_ERROR: 'Job creation limit reached. Contact to upgrade.',
    PROFILE_VIEW_ERROR: 'Profile view limit reached. Please contact support for further assistance.',
    JOB_EXISTS_ERROR: 'This job does not exist, or you may not have access to view it. Please contact support for assistance.',
    JOB_UPDATE_ERROR: 'Job update has been failed. Please try again!',
    EMPTY_CANDIDATE_GENERATE: 'No candidates found for the job description. Please refine your search.'
};

export const SUCCESS_MESSAGES = {
    ACCOUNT_CREATION_SUCCESS: 'Your account has been successfully created.',
    EMAIL_VERIFIED_SUCCESS: 'Your email has been successfully verified.',
    PASSWORD_CHANGED: 'Your password has been changed successfully.',
    OTP_SENT_SUCCESS: 'OTP has been sent to your email.',
    PROFILE_UPDATED: 'Your profile has been updated successfully.',
    CHANGE_PASSWORD_SUCCESS: 'Your password has been successfully changed. Please log in again with your new password.',
    FORGOT_OTP_SEND: 'OTP has been sent to your registered email.',
    LOGIN_SUCCESS: 'You have logged in successfully.',
    VERIFY_OTP_SUCCESS: 'OTP verified successfully.',
    RESET_PASSWORD_SUCCESS: 'Your profile password has been reset successfully.',
    LOGOUT_SUCCESS: 'You have logged out successfully.',
    PROFILE_SUCCESS: 'Your company profile has been updated successfully.',
    PROFILE_UPDATED_SUCCESS: 'Your profile has been updated successfully.',
    ACCOUNT_VERIFY_SUCCESS: 'Account approved successfully.',
    TIER_SUCCESS: 'Plan added successfully.',
    TIER_EDITED_SUCCESS: 'Plan updated successfully.',
    TIER_DELETED_SUCCESS: 'Plan deleted successfully.',
    ACCOUNT_REJECT_SUCCESS: 'Account rejected successfully.',
    JOB_SUCCESS: 'Job generated successfully.',
    USER_DEACTIVATE_SUCCESS: 'User deactivated successfully.',
    USER_ACTIVATE_SUCCESS: 'User activated successfully.',
    JOB_UPDATE_SUCCESS: 'Job description updated successfully.',
    JOB_DELETED_SUCCESS: 'Job deleted successfully.',
    SWITCH_USER_SUCCESS: 'Switch to user profile successfully.',
    DUPLICATE_JOB_SUCCESS: 'Job duplicated successfully',
    CHANGE_PLAN_SUCCESS: 'User plan updated successfully',
    SIGNUP_SUCCESS: 'Thank you for signing up! Enjoy your free account.'
};
